/**
 * @generated SignedSource<<0b6b6bce83ef3b981a24c6d6493526fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
export type WSTaskSingleQuery$variables = {
  id: string;
};
export type WSTaskSingleQuery$data = {
  readonly widgetTaskSingle: {
    readonly activeSectionVersions: ReadonlyArray<{
      readonly id: string;
      readonly section: {
        readonly id: string;
      };
    }>;
    readonly id: string;
    readonly task: {
      readonly activeSectionVersions: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly routine: {
        readonly type: RoutineType;
      };
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleSettingsScreenComponent_task">;
    } | null;
  } | null;
};
export type WSTaskSingleQuery = {
  response: WSTaskSingleQuery$data;
  variables: WSTaskSingleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineSectionVersion",
  "kind": "LinkedField",
  "name": "activeSectionVersions",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTaskSingleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetTaskSingle",
        "kind": "LinkedField",
        "name": "widgetTaskSingle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "activeSectionVersions",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTaskSingleSettingsScreenComponent_task"
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSTaskSingleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetTaskSingle",
        "kind": "LinkedField",
        "name": "widgetTaskSingle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "activeSectionVersions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "ownerTeam",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isTask"
              },
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit",
                    "storageKey": null
                  }
                ],
                "type": "TaskNumber",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentiments",
                    "storageKey": null
                  }
                ],
                "type": "TaskCheck",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44cb46c66894639f7fbaa3a10e5fbcc5",
    "id": null,
    "metadata": {},
    "name": "WSTaskSingleQuery",
    "operationKind": "query",
    "text": "query WSTaskSingleQuery(\n  $id: ID!\n) {\n  widgetTaskSingle(id: $id) {\n    id\n    task {\n      __typename\n      id\n      activeSectionVersions {\n        id\n      }\n      routine {\n        type\n        id\n      }\n      ...WidgetTaskSingleSettingsScreenComponent_task\n    }\n    activeSectionVersions {\n      id\n      section {\n        id\n      }\n    }\n  }\n}\n\nfragment ListSectionHeaderRoutine_Routine on Routine {\n  title\n  ownerTeam {\n    ...TeamIconCircleComponent_Team\n    id\n  }\n}\n\nfragment RoutineSectionListItem_RoutineSectionVersion on RoutineSectionVersion {\n  title\n  section {\n    assignedTeam {\n      ...TeamIconCircleComponent_Team\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment TaskListItemIcon_Task on Task {\n  __isTask: __typename\n  __typename\n  ... on TaskNumber {\n    unit\n  }\n  ... on TaskCheck {\n    sentiments\n  }\n  ... on TaskText {\n    __typename\n  }\n}\n\nfragment TaskListItemTitle_Task on Task {\n  __isTask: __typename\n  title\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment WidgetTaskSingleSettingsScreenComponentTask_task on Task {\n  __isTask: __typename\n  ...TaskListItemIcon_Task\n  ...TaskListItemTitle_Task\n  routine {\n    ...ListSectionHeaderRoutine_Routine\n    id\n  }\n}\n\nfragment WidgetTaskSingleSettingsScreenComponent_task on Task {\n  __isTask: __typename\n  id\n  routine {\n    type\n    id\n  }\n  ...WidgetTaskSingleSettingsScreenComponentTask_task\n  activeSectionVersions {\n    id\n    section {\n      id\n    }\n    ...RoutineSectionListItem_RoutineSectionVersion\n  }\n}\n"
  }
};
})();

(node as any).hash = "73f9c343b4c49163f54cf298b0715023";

export default node;
